import * as React from 'react';
import { Link } from 'gatsby';

export interface BreadcrumbProps {
    crumbs: {
        crumbLabel: string;
        pathName: string;
    }[];
}

const CustomBreadcrumb: React.FC<BreadcrumbProps> = ({
    crumbs
}) => {

    const homeSVG = (<svg aria-hidden="true" className="w-4 h-4 mr-2" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z"></path></svg>);
    const defaultCrumbSeparator = (<svg aria-hidden="true" className="w-6 h-6 text-gray-300" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd"></path></svg>);

    const homeTrail = (
        <>
            <Link to={'/'} className='flex flex-row items-center justify-center content-center text-sm font-medium md:ml-0 text-white hover:text-red-500'>
                {homeSVG}
                {'Home'}
            </Link>
            {defaultCrumbSeparator}
        </>
    );

    console.log(crumbs);

    return (
        <nav className='flex mt-5 pt-3 text-gray-700 rounded-lg px-0' aria-label="Breadcrumb">
            <ul className='inline-flex items-center space-x-1'>
                {crumbs.map((crumb, index) => (
                    <li key={crumb.pathName} className='flex items-center'>
                        {index === 0 && homeTrail}
                        {index > 0 && defaultCrumbSeparator}
                        {crumb.crumbLabel && (
                            <Link to={crumb.pathName} className='ml-0 text-xs text-center sm:text-left sm:text-sm font-medium md:ml-0 text-white hover:text-red-500'>
                                {crumb.crumbLabel}
                            </Link>
                        )}
                    </li>
                ))}
            </ul>
        </nav>
    );
};

export default CustomBreadcrumb;
